import PropTypes from 'prop-types'

export const Toggle = ({ enabled, onChange, disabled = false, size = 'md', label, srLabel }) => {
  const sizes = {
    sm: { toggle: 'h-5 w-9', thumb: 'h-3 w-3', translate: 'translate-x-5' },
    md: { toggle: 'h-6 w-11', thumb: 'h-4 w-4', translate: 'translate-x-6' },
    lg: { toggle: 'h-7 w-14', thumb: 'h-5 w-5', translate: 'translate-x-8' },
  }

  const currentSize = sizes[size] || sizes.md

  return (
    <button
      type="button"
      onClick={() => !disabled && onChange(!enabled)}
      disabled={disabled}
      className={`relative inline-flex ${currentSize.toggle} items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 focus:ring-offset-gray-900 ${
        enabled ? 'bg-blue-600' : 'bg-gray-600'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      aria-pressed={enabled}
      aria-label={srLabel || label || 'Toggle setting'}
    >
      <span
        className={`inline-block ${currentSize.thumb} transform rounded-full bg-white transition-transform ${
          enabled ? currentSize.translate : 'translate-x-1'
        }`}
      />
    </button>
  )
}

Toggle.propTypes = {
  enabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  label: PropTypes.string,
  srLabel: PropTypes.string,
}

export default Toggle
